import React, { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FloatLabel } from 'primereact/floatlabel';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { MultiSelect } from 'primereact/multiselect';
import { Checkbox } from 'primereact/checkbox';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { Dropdown } from 'primereact/dropdown';

const AddEditCoScholasticGradeTemplate = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [titleName, setTitleName] = useState('');
    const [titleNameErr, setTitleNameErr] = useState(false);
    const [titleNameErrText, setTitleNameErrText] = useState('');
    const [classList, setClassList] = useState([]);
    const [className, setClassName] = useState([]);
    const [termList, setTermList] = useState([]);
    const [termName, setTermName] = useState([]);
    const [isClassTeacher, setIsClassTeacher] = useState(true);
    const [isSubjectTeacher, setIsSubjectTeacher] = useState('');
    const [dateRange, setDateRange] = useState([]);
    const [dateRangeErr, setDateRangeErr] = useState(false);
    const [dateRangeErrText, setDateRangeErrText] = useState('');
    const [teachersList, setTeachersList] = useState([]);
    const [coScholasticList, setCoScholasticList] = useState([]);
    const [coScholasticType, setCoScholasticType] = useState([]);

    const titleNameRef = useRef(null);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        setTimeout(() => {
            titleNameRef.current?.focus();
        }, 100);
    }, []);


    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetTeachersList(loginData?._id);
        GetCoScholasticTypeList(loginData?._id);
        GetClassList(loginData?._id);
        GetTermsList(loginData?._id);
        if (props?.configId) {
            setTitleName(props?.masterData?.TemplateName);
            setClassName(props?.masterData?.ClassId ? props?.masterData?.ClassId.split(',') : []);
            setIsSubjectTeacher(props?.masterData?.IsSubjectTeacher);
            setIsClassTeacher(props?.masterData?.IsClassTeacher);
            setCoScholasticType(props?.masterData?.CoScholasticType ? props?.masterData?.CoScholasticType?.split(',') : []);
            setTermName(props?.masterData?.TermName ? props?.masterData?.TermName.split(',') : []);
            setDateRange([props?.masterData?.StartDate ? new Date(props?.masterData?.StartDate) : null, props?.masterData?.EndDate ? new Date(props?.masterData?.EndDate) : null]);
        }
    }, []);

    const GetTeachersList = async (id) => {
        try {
            const data = { UserID: id };
            await api.post(APIConstant.path.getUser, data).then(async response => {
                if (response.success) {
                    const dataList = response.data
                        .filter((x) => x.UserType === 'Teacher' && x?.Status === 'Active')
                        .map((y) => ({
                            ...y,
                            label: y.Name,
                            value: y._id
                        }));
                    setTeachersList(dataList);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    };

    const GetCoScholasticTypeList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getCoScholasticList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setCoScholasticList(res?.data?.map((x) => ({
                        ...x,
                        value: x?._id,
                        label: `${x?.CoScholasticName} (${x?.Type})`
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetClassList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(
                        Array.from(
                            new Map(
                                res?.data?.filter(x => x?.Status === 'Active')?.map((x) => [
                                    x?.ClassId,
                                    {
                                        ...x,
                                        value: x?.ClassId,
                                        label: `${x?.ClassName}-${x?.MediumName}-${x?.Board}`
                                    }
                                ])
                            ).values()
                        )
                    );

                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetTermsList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getTermList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setTermList(res?.data?.map(x => ({
                        label: x?.TermName,
                        value: x?._id,
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const getDateOnly = (date) => {
        if (!date) return null;
        const d = new Date(date);
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    };

    const handleDateRangeChange = (value) => {
        setDateRange(value);
        let [startDate, endDate] = value || [];
        startDate = getDateOnly(startDate);
        endDate = getDateOnly(endDate);

        if (startDate && endDate) {
            if (startDate > endDate) {
                setDateRangeErr(true);
                setDateRangeErrText("'Start' date cannot be after 'End' date.");
            } else if (startDate.getTime() === endDate.getTime()) {
                setDateRangeErr(true);
                setDateRangeErrText("'Start' and 'End' date cannot be the same.");
            } else {
                setDateRangeErr(false);
                setDateRangeErrText("");
            }
        }
    };

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(titleName)) {
            formIsValid = false;
            setTitleNameErr(true);
            setTitleNameErrText("Title Name is required");
        } else {
            setTitleNameErr(false);
            setTitleNameErrText("");
        }
        return formIsValid;
    };

    const onCancel = () => {
        props.onCancel();
        setTitleName('');
        setClassName([]);
        setDateRange('');
    }

    const AddUpdateTemplate = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                const [startDate, endDate] = dateRange || [];
                let data = {
                    id: props?.configId,
                    TemplateName: titleName.trim().replace(/\s+/g, ' '),
                    ClassId: className ? className.length > 1 ? className.join(',') : className[0] : '',
                    TermName: termName ? termName.length > 1 ? termName.join(',') : termName[0] : '',
                    IsClassTeacher: isClassTeacher,
                    IsSubjectTeacher: isSubjectTeacher,
                    CoScholasticType: coScholasticType ? coScholasticType.length > 1 ? coScholasticType.join(',') : coScholasticType[0] : '',
                    StartDate: startDate ? moment(startDate).format("YYYY-MM-DD") : '',
                    EndDate: endDate ? moment(endDate).format("YYYY-MM-DD") : '',
                    CreatedBy: securityUserID,
                };
                await api
                    .post(APIConstant.path.AddUpdateCoScholasticGradeTemplate, data)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                            onCancel();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Toast.error({ message: err });
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };


    return (
        <div className="p-d-flex p-flex-column p-jc-between">
            <div className='p-grid'>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <div className='custom-inputs'>
                        <label htmlFor="titleName">Name</label>
                        <FloatLabel>
                            <InputText
                                ref={titleNameRef}
                                className='p-w-100 p-mt-1'
                                id="titleName"
                                value={titleName}
                                onChange={(e) => setTitleName(e.target.value)}
                                style={{
                                    fontFamily: "Noto Sans, Arial, sans-serif"
                                }}
                            />
                        </FloatLabel>
                    </div>
                    <span className="error-msg" style={{ color: 'red' }}>
                        {titleNameErr ? titleNameErrText : null}
                    </span>
                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <div className="e-add-fee-structure">
                        <div className='custom-inputs'>
                            <label htmlFor="className">Class</label>
                            <MultiSelect
                                id="className"
                                value={className}
                                options={classList}
                                onChange={(e) => setClassName(e.value)}
                                placeholder="Select Class"
                                display="chip"
                                className='p-w-100 p-mt-1'
                                filter
                            />
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <div className="">
                        <Checkbox
                            inputId="classTeacher"
                            name="isClassTeacher"
                            value="IsClassTeacher"
                            onChange={(e) => {
                                setIsClassTeacher(e.checked);
                            }}
                            checked={isClassTeacher}
                        />
                        <label htmlFor="classTeacher" className="ml-2"> Class Teacher</label>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <div className="">
                        <label htmlFor="subjectTeacher">Subject Teacher</label>
                        <Dropdown
                            id="subjectTeacher"
                            value={isSubjectTeacher}
                            options={teachersList}
                            onChange={(e) => setIsSubjectTeacher(e.value)}
                            placeholder="Select Subject Teacher"
                            display="chip"
                            className='p-w-100 p-mt-1'
                            filter
                        />
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <div className="">
                        <label htmlFor="coScholasticType">Co-Scholastic Type</label>
                        <MultiSelect
                            id="coScholasticType"
                            value={coScholasticType}
                            options={coScholasticList}
                            onChange={(e) => setCoScholasticType(e.value)}
                            placeholder="Select CoScholastic Type"
                            display="chip"
                            className='p-w-100 p-mt-1'
                            filter
                        />
                    </div>
                </div>

                <div className="p-col-12 p-md-6 p-pt-2">
                    <div className='custom-inputs'>
                        <label htmlFor="startDate">Start Date Range</label>
                        <div className="custom-inputs">
                            <Calendar
                                id="dateRange"
                                value={dateRange}
                                onChange={(e) => handleDateRangeChange(e.value)}
                                selectionMode="range"
                                // readOnlyInput
                                dateFormat="dd/mm/yy"
                                className="p-w-100 p-mt-1"
                                hourFormat="12"
                                showButtonBar
                            />
                            <span className="error-msg" style={{ color: 'red' }}>
                                {dateRangeErr ? dateRangeErrText : null}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <div className="e-add-fee-structure">
                        <div className='custom-inputs'>
                            <label htmlFor="termName">Term</label>
                            <MultiSelect
                                id="termName"
                                value={termName}
                                options={termList}
                                onChange={(e) => setTermName(e.value)}
                                placeholder="Select Term"
                                display="chip"
                                className='p-w-100 p-mt-1'
                                filter
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
                <Button className='p-m-0 btn-text-action-secondary p-m-1' label="Cancel" onClick={(e) => onCancel()} />
                <Button className='p-m-0 btn-text-action-primary' label="Save" onClick={(e) => AddUpdateTemplate()} />
            </div>
        </div >
    );
};

export default AddEditCoScholasticGradeTemplate;
